import { render, staticRenderFns } from "./DeviceViewPCContent.vue?vue&type=template&id=164f1fcf&scoped=true&"
import script from "./DeviceViewPCContent.vue?vue&type=script&lang=js&"
export * from "./DeviceViewPCContent.vue?vue&type=script&lang=js&"
import style0 from "./DeviceViewPCContent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DeviceViewPCContent.vue?vue&type=style&index=1&id=164f1fcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164f1fcf",
  null
  
)

export default component.exports